import type { TwiageCase } from "@/App/types/twiageTypes";
import { IdComparator, updateInList } from "@/App/utils/updateInList";

export const updateCaseInTheList = ({
  cases,
  caseId,
  getCaseUpdate,
}: {
  cases: TwiageCase[];
  caseId: string;
  getCaseUpdate: (twiageCase: TwiageCase) => Partial<TwiageCase>;
}): void => {
  cases.find((aCase) => {
    if (aCase.id === caseId) {
      updateInList({ list: cases, updatedItem: { ...aCase, ...getCaseUpdate(aCase) }, comparator: IdComparator });
    }
  });
};
